import { Component, computed, OnInit, Signal } from '@angular/core';
import { Details, OnboardingState } from '@airwallet/shared-models/details';
import { SubCustomerPermission } from '@airwallet/shared-models/sub-customer';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { OnboardingService } from '../../../services/onboarding/onboarding.service';
import { DashboardOwnerUser } from '@dashboard_models/dashboard-owner-user';
import * as Claims from '@airwallet/shared-models/claims';
import { LoadingComponent } from '../../loading/loading.component';
import { NgIf } from '@angular/common';
import { AccountService } from '@services/account/account.service';
import { HomeService } from '@services/home/home.service';

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    imports: [NgIf, LoadingComponent, TranslateModule]
})
export class OnboardingComponent implements OnInit {
    customerDetails: Signal<Details> = this.homeService.customerDetails;
    subCustomerPermissions: Signal<SubCustomerPermission> = this.onboardingService.subCustomerPermissions;

    noShare: Signal<boolean> = this.onboardingService.noShare;
    onboardingState: Signal<OnboardingState> = this.onboardingService.onboardingState;
    isLife: Signal<boolean> = this.onboardingService.isLife;
    user: DashboardOwnerUser;

    role: Signal<Claims.Role> = this.authService.getRole;
    onboardingComplete: Signal<boolean> = this.onboardingService.onboardingComplete;
    showLoadingIndicator = false;
    showSmallLoadingIndicator = false;

    hasCompletedAccountInformation: Signal<boolean> = this.onboardingService.hasCompletedAccountInformation;
    shouldShowKYC: Signal<boolean> = this.onboardingService.shouldShowKYC;
    nextStepIsKYC: Signal<boolean> = computed(() => {
        const canEditKYC: boolean = this.authService.hasLimitedAccess('edit_kyc', this.role());
        return this.hasCompletedAccountInformation() && (canEditKYC || this.noShare());
    });
    shouldShowPlanAndBilling: Signal<boolean> = this.onboardingService.shouldShowPlanAndBilling;
    hasCompletedPlan: Signal<boolean> = this.onboardingService.hasCompletedPlan;
    hasCompletedKYC: Signal<boolean> = this.onboardingService.hasCompletedKYC;
    nextStepIsBilling: Signal<boolean> = this.onboardingService.nextStepIsBilling;

    constructor(
        public translate: TranslateService,
        private router: Router,
        private onboardingService: OnboardingService,
        public authService: AuthService,
        private accountService: AccountService,
        private homeService: HomeService
    ) {}

    async ngOnInit() {
        await this.handleOnboardingCompleteCheck();
        if (!this.accountService.currentSubscriptionPlanInfo()) {
            await this.accountService.getSubscriptionPlanInfo();
        }
    }

    async handleOnboardingCompleteCheck(): Promise<void> {
        await this.onboardingService.getOnboardingStatus();
    }

    onboardingAction(action: 'external_account' | 'capabilities' | 'billing' | 'plan') {
        if (action === 'capabilities') {
            this.goToStripeKYC();
            return;
        }
        if (action === 'plan') {
            this.router.navigate(['account/subscription-plan']);
        } else {
            this.router.navigate([`${action === 'billing' ? 'billing' : 'account/onboarding'}`]);
        }
    }

    goToStripeKYC() {
        this.showSmallLoadingIndicator = true;
        this.onboardingService.getStripeKYCUrl().catch(error => {
            this.showSmallLoadingIndicator = false;
        });
    }
}
